/*
    Handles pages that require auth, redirecting to login if necessary
 */
import { signIn, useSession } from "next-auth/react"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { Center } from "@chakra-ui/react"
import LoadingIndicator from "components/ui/LoadingIndicator"
import LoginModal from "components/login/loginModal"

export default function PageGuard({ pageStatus, children }) {
    const { data: session, status } = useSession()
    const router = useRouter()
    const [isLoggingIn, setIsLoggingIn] = useState(false)

    useEffect(() => {
        if (status === "loading") return

        const login = async () => {
            try {
                await signIn("okta")
            } catch (error) {
                console.error("Sign-in error:", error)
                setIsLoggingIn(false)
            }
        }

        if (!userCanAccess(session?.user, pageStatus)) {
            setIsLoggingIn(true)
            void login()
        }
    }, [session, status, router.asPath, pageStatus])

    if (userCanAccess(session?.user, pageStatus)) {
        return children
    }

    // Show loader while session is being fetched. If no user, useEffect() will redirect to sign-in
    return (
        <Center w="100vw" h="100vh">
            {isLoggingIn ? <LoginModal /> : <LoadingIndicator />}
        </Center>
    )
}

function userCanAccess(user, pageStatus) {
    if (!user && ["loggedInOnly", "crfStaffOnly"].includes(pageStatus)) {
        return false
    }

    if (!user?.isCrfStaff && pageStatus === "crfStaffOnly") {
        return false
    }

    return true
}
